import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IDegreeType } from "./routeType";

const { key, getPath } = getApi("types.degree.getAll");

type IExtractedRouteType = IDegreeType["DegreeTypeCollectionRetrieve"];

export type IGetDegreeType = IPickCollectionQuery<IExtractedRouteType>;

const getDegreeType: Fetcher<
  IGetDegreeType["response"],
  IGetDegreeType["variables"]
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetDegreeType = createQuery({
  queryKey: [key],
  fetcher: getDegreeType,
});
